export * from './no-result.component';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/display/no-result/index.ts